/**
 * Created by staffanrantzow on 07/10/16.
 */

import React from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { Utils, UserService } from 'frilans-finans';
import { SpinnerButton, InputField, GeneralError } from 'components';

export class ForgotPasswordView extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      formValues: {
        email: {
          value: '',
          valid: false
        }
      },
      showErrorWithoutBlur: false,
      error: false,
      posted: false,
      loading: false
    };

    this.callback = this.callback.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  callback (name, values) {
    var tempFormValues = this.state.formValues;

    Object.assign(tempFormValues[name], values);
    this.setState({formValues: tempFormValues});
  }

  submitForm (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (Utils.validateInputValues(this.state.formValues)) {
        this.setState({
          loading: true,
          posted: false,
          error: false
        }, this.post);
      }
    });
  }

  post () {
    UserService.resetPassword(this.state.formValues.email.value)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));
  }

  handleSuccess () {
    this.setState({
      loading: false,
      posted: true,
      error: false
    });
  }

  handleError () {
    this.setState({
      loading: false,
      posted: true,
      error: true
    });
  }

  renderPostError () {
    if (this.state.error) {
      return (<GeneralError/>);
    }
  }

  renderContent () {
    if (this.state.posted) {
      return (<p className='info'><Translate content='RESET_PASSWORD_SUCCESS'/></p>);
    }

    return (
      <div>
        <p><Translate content='RESET_PASSWORD_TEXT'/></p>
        <form noValidate onSubmit={this.submitForm}>
          <InputField type='email' name='email' value={this.state.formValues.email.value}
            placeholder={proxyCounterpart('EMAIL')} callback={this.callback}
            required='true' minLength='3' errorMessage={proxyCounterpart('EMAIL_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />

          {this.renderPostError()}

          <SpinnerButton text={proxyCounterpart('SEND')}
            loading={this.state.loading} classes='btn'/>
        </form>
      </div>
    );
  }

  render () {
    return (
      <div className="container forgot-password">
        <div className="row">
          <div className='col-sm-6 col-sm-push-3'>
            <h2><Translate content='RESET_PASSWORD'/></h2>
          </div>
        </div>
        <div className="row">
          <div className='col-sm-6 col-sm-push-3'>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

}

export default ForgotPasswordView;



/** WEBPACK FOOTER **
 ** ./src/views/forgot-password-view/forgot-password-view.js
 **/